module.exports = __webpack_public_path__ + "img/service-noimage.b645ef47.svg";